
riot.tag2('week-days-checkbox', '  <div class="btn-group"><span class="btn btn-sm btn-default {btn-primary: parseInt(value[i])}" each="{day, i in days}" onclick="{click}">{day}</span></div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.days = ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'];
self.value = '0000000'.split('');

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value.join('');
    },
    set: function set(value) {
        if (!value) {
            self.value = '0000000'.split('');
        } else {
            self.value = value.toString().split('');
        }
    }
});

self.click = function (e) {
    self.value[e.item.i] = self.value[e.item.i] === '0' ? '1' : '0';
    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.on('mount', function () {
    self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./components/week-days-checkbox.tag